<template>
  <div class="cpm-wrapper">
    <div class="cpm-body">
      <el-dialog title="未满起送金额" :visible.sync="dialogVisible" width="620px" :close-on-click-modal="false">
        <div class="dialog-content">
          <div class="list-warp">
            <div class="list-warp-content" v-for="(item, index) in list" :key="`addon_${index}`">
              <div
                v-if="item.remainLackStartDelivery > 0 && item.remainLackStartDelivery < item.startDeliveryThreshold"
                class="list-item "
              >
                <div class="left">
                  <div class="store-icon">
                    <img v-if="item.shopIcon && item.shopIcon != ''" :src="item.shopIcon" alt="" class="shop-logo" />
                    <img v-else :src="require('@/assets/img/shop-logo.png')" class="shop-logo" />
                  </div>
                  <div>
                    <div class="add-name">{{ item.shopName }}</div>
                    <div class="add-text">
                      <span>满</span>
                      <span class="price" v-html="price(item.startDeliveryThreshold)"></span>
                      <span>元起送，还差</span>
                      <span class="price" v-html="price(item.remainLackStartDelivery)"></span>
                      <span>元</span>
                    </div>
                  </div>
                </div>
                <div class="goAdd pointer" @click="goShop(item.shopId)">
                  去凑单
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button style="border-radius:0" type="primary" @click="onSubmit">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as api from '@/services';
import { priceFenToYuan, throttle } from '@/helpers/utils';
export default {
  props: {
    list: {}
  },
  watch: {
    dialogVisible: {
      handler(val) {}
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  methods: {
    async onSubmit() {
      this.dialogVisible = false;
    },
    goShop(shopId) {
      window.open(encodeURI(location.origin + location.pathname + `#/store/${shopId}/goods`));
    },
    price(val) {
      return priceFenToYuan(val);
    }
  }
};
</script>

<style lang="scss" scoped>
.cpm-wrapper {
  .cpm-body {
    .dialog-content {
      font-size: 12px;

      .list-warp {
        min-height: 347px;
        .list-warp-content {
          position: relative;
          .list-item {
            height: 62px;
            border-bottom: 1px solid #eeeeee;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left {
              display: flex;
              align-items: center;
            }
            .store-icon {
              display: flex;
              align-items: center;
              img {
                width: 30px;
                height: 30px;
                border-radius: 2px;
                margin-right: 8px;
              }
            }
            .add-text {
              font-size: 12px;
              font-weight: 400;
              color: #333333;
              line-height: 12px;
            }
            .price {
              color: #d96900;
            }
            .add-name {
              margin-bottom: 6px;
              width: 300px;
              height: 12px;
              font-size: 12px;
              font-weight: 400;
              color: #333333;
              line-height: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .goAdd {
              height: 12px;
              font-size: 12px;
              font-weight: 400;
              color: #1e8dff;
              line-height: 12px;
            }
          }
        }
      }
    }
    .dialog-footer {
      text-align: right;
    }
  }
}
</style>
